/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Faq_2_QInputs */

const en_pc_faq_2_q = /** @type {(inputs: Pc_Faq_2_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is ArtCraft open source?`)
};

const zh_pc_faq_2_q = /** @type {(inputs: Pc_Faq_2_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ArtCraft 是开源的吗？`)
};

/**
* | output |
* | --- |
* | "Is ArtCraft open source?" |
*
* @param {Pc_Faq_2_QInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_faq_2_q = /** @type {((inputs?: Pc_Faq_2_QInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Faq_2_QInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_faq_2_q(inputs)
	return zh_pc_faq_2_q(inputs)
});
export { pc_faq_2_q as "pc.faq.2.q" }